import { useState, useEffect } from 'react';
import Popover from '@mui/material/Popover';
import IconBtn from 'components/common/IconBtn';
import { useWindowSize } from 'hooks/useWindowSize';
import { Notification } from 'api/models/response/Notifications';
import { FakeInput } from '../Dashboard.styled';
import * as S from './Notifications.styled';

const dateOptions: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: '2-digit',

    hour: '2-digit',
    minute: '2-digit',
};

interface NotificationPopoverProps {
    notification: Notification;
    anchorPosition: { left: number; top: number } | undefined;
    clickedId: number | undefined;
}

const NotificationPopover = ({
    notification,
    anchorPosition,
    clickedId,
}: NotificationPopoverProps) => {
    const id = anchorPosition ? 'simple-popover' : undefined;
    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        if (width >= 769) {
            setMobile(false);
        }
        if (width < 769) {
            setMobile(true);
        }
    }, [width, height]);

    return (
        <>
            <S.Notification isActive={clickedId === notification.id} />

            <Popover
                id={id}
                open={clickedId === notification.id}
                anchorReference="anchorPosition"
                anchorPosition={anchorPosition}
                anchorOrigin={{
                    vertical: mobile ? 'top' : 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '7rem',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: mobile ? 'bottom' : 'top' }}
            >
                <S.Container>
                    <div
                        style={{
                            display: 'flex',
                            paddingRight: '0.2rem',
                            paddingTop: '0.2rem',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <IconBtn
                            style={{
                                height: '24px',
                                width: '24px',
                                alignSelf: 'flex-end',
                                transform: 'scale(1.2)',
                                margin: '2px 2px 0px 0px',
                            }}
                            onClick={() => console.log('')}
                        >
                            <S.CrossSimpleIcon />
                        </IconBtn>
                    </div>
                    <S.FullNotification>
                        <FakeInput style={{ padding: '10px 20px' }}>
                            {notification.created_at && (
                                <S.CreatedAt style={{ display: 'flex', justifyContent: 'center' }}>
                                    {new Date(notification.created_at).toLocaleString(
                                        'en-US',
                                        dateOptions
                                    )}
                                </S.CreatedAt>
                            )}
                        </FakeInput>
                        {notification.url ? (
                            <a
                                href={notification.url}
                                style={{
                                    cursor: 'pointer',
                                }}
                            >
                                <FakeInput>{notification.message}</FakeInput>
                            </a>
                        ) : (
                            <span>
                                <FakeInput>{notification.message}</FakeInput>
                            </span>
                        )}
                    </S.FullNotification>
                </S.Container>
            </Popover>
        </>
    );
};

export default NotificationPopover;
